export default __webpack_public_path__ + "static/media/twitter.a9ba461c.svg";